module.exports = __webpack_public_path__ + "5de4d676c3df0d4411ca55b899a88adf.svg";